import PropTypes from 'prop-types';
import React from 'react';
import './NativeValueInput.css';

class NativeValueInput extends React.Component {
  constructor() {
    super(...arguments);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.props.onInputChange([e.target.value]);
  }

  render() {
    const {
      values: [value = ''],
      type,
      id,
    } = this.props;

    return (
      <input
        className="NativeValueInput"
        type={type}
        ref={ref => (this.input = ref)}
        onChange={this.handleChange}
        value={value}
        id={id}
      />
    );
  }
}

NativeValueInput.propTypes = {
  values: PropTypes.array.isRequired,
  onInputChange: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default NativeValueInput;
